<template>
  <div
    class="modal nb-modal-mask"
    style="display:block; z-index: 1 !important;"
    :style="showClass"
  >
    <div class="">
      <div class="" style="">
        <!--Modal editItem atalho-->
        <div
          class="modal nb-modal-mask nb-modal-mas-tranparent"
          style="display: block"
          @keyup.esc="handleRetorna()"
        >
          <div
            class="modal-dialog modal-dialog-centered modal-md"
            role="document"
            style="overflow-y: initial !important; "
            @keyup.esc="handleRetorna()"
          >
            <div class="modal-content ">
              <div
                class="modal-body"
                style="overflow-y: auto"
              >
                    <div class="row">
                      <div class="col-md-12 col-12">
                        <span class="lbl mb-4" style="font-size: 20px">
                          <strong>
                  {{
                    modalCrud == "delete"
                      ? "Exclusão de Item"
                      : "Selecione o item"
                  }}
                          </strong>
                        </span>
                        <button type="button" ref="ediitemclose" class="close" @click="handleRetorna()" data-dismiss="modal"
                          aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                    </div>

                <div class="mb-4" v-if="!pedvit || pedvit.length == 0">
                  <i class="lbl-title fa fa-exclamation-triangle mr-2"></i
                  ><span class="lbl-title"
                    >Não possui itens para
                    {{ modalCrud == "delete" ? "deletar" : "editar" }}</span
                  >
                </div>
                <div class="d-flex flex-column" v-else>
                  <form-field
                    :type="'number'"
                    label="Informe o Numero do Item"
                    v-model.number="editItemValue"
                    @keyenter="handleEnterModalEditIt()"
                    @input="handleInputModalEditIt()"
                    ref="itemvalue"
                    col="6">
                    <div>
                      <span class="text-danger">{{
                        errMessageModalEditItem
                      }}</span>
                    </div>
                  </form-field>
                  <div class="" v-if="modalCrud == 'delete'">
                    <form-field
                      ref="senhaModal"
                      v-model="adminPass"
                      type="password"
                      col="6"
                      label="Digite a senha de administrador"
                      @keyenter="handleConfirmButtonPass()">
                    </form-field>
                  </div>
                  <div class="col-md-12 col-12 mt-3">
                    <button type="button" ref="btnConfirm" class="btn-danger btn btn-sm" @click="handleConfirmButtonPass()">
                      Confirmar
                    </button>
                    <button type="button" ref="btnClose" class="btn btn-outline-secondary btn-sm" data-dismiss="modal" @click="handleRetorna()">
                      Cancelar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fecharCaixa from "./varejo-fecharcaixa-form";
import { apiORDSpost } from "../shared/api-functions";

export default {
  props: {
    index: "",
    pedvit: "",
    modalCrud: "",
    teste: "",
    pedv: "",
    value: ""
  },

  components: {
    fecharCaixa
  },

  data() {
    return {
      show: false,
      adminPass: "",
      editItemValue: "",
      errMessageModalEditItem: "",
      pedvit_update: ""
    };
  },

  computed: {
    showClass: function() {
      if (!this.show) return "transform: translate3d(0%, 100%, 0);";
      else return "transform: translate3d(0%, 0, 0);";
    }
  },

  watch: {},

  filters: {},

  methods: {
    handleItemCancel(index) {
      if (this.editItemValue) {
        index--;
      }
      if (this.pedv.stpedv != "D" && this.pedv.stpedv != "P") return;

      this.pedvit_update = index;
    },
    async handleConfirmButtonPass() {
      if (!this.adminPass || this.adminPass == "") {
        this.$erpToastError("Senha obrigatoria");
        return;
      }
      //executa a rotina do Enter do campo da sequencia do item
      this.handleEnterModalEditIt();
      let obj = {};
      obj.senha = this.adminPass;

      var modulo = "cg/valida/adminpass/";
      const data = await apiORDSpost(this.$store, modulo, obj, "post");
      if (!data.resultado) {
        this.$erpToastError("Senha invalida");
        return;
      }
      this.$emit("confirmedPass", this.pedvit_update);
    },
    handleEnterModalEditIt() {
      if (this.editItemValue <= this.pedvit.length && this.editItemValue != 0) {
        this.modalCrud == "delete" && this.editItemValue
          ? this.handleItemCancel(this.editItemValue)
          : this.modalCrud == "update" && this.editItemValue
          ? this.$emit("updateMode", this.editItemValue)
          : "";
      }
      if (
        this.editItemValue == 0 ||
        this.editItemValue == null ||
        this.editItemValue > this.pedvit.length
      ) {
        //Envia foco de volta ao input do component varejo-item-modal-side-form
        this.errMessageModalEditItem = "Valor não permitido";

        this.$nextTick(function() {
          this.$refs.itemvalue.focus();
        });
      }
    },
    handleRetorna() {
      this.editItemValue = null;
      this.$emit("closeModal");
    },
    handleInputModalEditIt() {
      if (this.editItemValue > this.pedvit.length) {
        if (this.editItemValue == null || this.editItemValue == 0) {
          return (this.errMessageModalEditItem = "");
        } else {
          this.errMessageModalEditItem = "Valor não permitido";
        }
      } else {
        this.errMessageModalEditItem = "";
      }
    }
  },

  created() {},

  mounted() {
    if (this.pedvit.length <= 0) {
      this.$nextTick(function() {
        this.$refs.closeModalBtn.focus();
      });
    }
    let vm = this;
    this.keytimer = setTimeout(function() {
      // console.log(vm.filtros)
      vm.show = true;
    }, 100);

    if (this.value) {
      this.editItemValue = this.value;
      this.$nextTick(function() {
        this.$refs.senhaModal.focus();
      });
      return;
    }
    this.$nextTick(function() {
      this.$refs.itemvalue.focus();
    });
  }
};
</script>

<style>
.side-form {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  transform: translate3d(0%, 0, 0);
  transition: all 0.35s;
  will-change: transform;
  z-index: 10000;
}

.side-form-shadow {
  box-shadow: 0 0 32px 0 #a9aaac80;
}

.side-form-inner {
  display: flex;
  flex-direction: column;
  background-color: rgba(75, 71, 71, 0.658);
  width: 680px;
  overflow: hidden;
  height: 100%;
}

.side-form-footer {
  display: flex;
  align-items: center;
  background-color: #f5f5f5;
  padding: 10px 20px;
  flex: 0 0 78px;
}

.side-form-body {
  padding: 1rem !important;
  overflow-y: auto;
  height: 100%;
}

.nb-modal-mas-tranparent {
  background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/forms-varejo/varejo-modal-item-sequencia.vue